"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const page_filter_item_1 = require("./page-filter-item");
const uuid_1 = require("uuid");
const multilingual_type_helper_1 = require("../../../shared/multilingual-type-helper");
class PageFilterState {
    constructor(state, datasetId, id, title, isAutoApplyEnabled) {
        this.state = state;
        this.datasetId = datasetId;
        this.id = id;
        this.title = title;
        this.isAutoApplyEnabled = isAutoApplyEnabled;
    }
    static fromJSON(jsonObject) {
        const datasetId = jsonObject && jsonObject.datasetId || null;
        let state = jsonObject && jsonObject.state ?
            PageFilterState.stateFromJSON(jsonObject.state) : [];
        const id = jsonObject && jsonObject.componentId || uuid_1.v4();
        const title = jsonObject &&
            multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.title) || null;
        const isAutoApplyEnabled = jsonObject && jsonObject.autoApplyEnabled !== "" ? jsonObject.autoApplyEnabled : true;
        return new PageFilterState(state, datasetId, id, title, isAutoApplyEnabled);
    }
    static stateFromJSON(stateJSON) {
        let state = stateJSON ? JSON.parse(stateJSON) : [];
        state = state.map((item) => {
            return page_filter_item_1.PageFilterItem.fromJSON(item);
        });
        return state;
    }
    toJSON() {
        let state = this.state.map((item) => {
            return item.toJSON();
        });
        const title = this.title && multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.title) || null;
        return {
            datasetId: this.datasetId,
            state: JSON.stringify(state),
            componentId: this.id,
            title: title,
            autoApplyEnabled: this.isAutoApplyEnabled
        };
    }
}
exports.PageFilterState = PageFilterState;
//# sourceMappingURL=page-filter-state.js.map